export const preventDecimal = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.key === "." || e.key === ",") {
    e.preventDefault();
  }
};

// handles copy and pasting decimals
export const removeNonNum = (
  numericString: string,
  allowEmptyStrings: boolean = false
) => {
  if (allowEmptyStrings && numericString === "") {
    return "";
  }

  // Number strips leading zeroes, regex strips all non-number characters
  const removed = Number(numericString.replace(/[^0-9]*/g, ""));
  return `${removed}`;
};
